module.exports = __webpack_public_path__ + "static/media/ContactEditPen.34d54b39.svg";